import colors from 'style-utils/colors';
import styled from 'styled-components';

export const DescriptiveIntroContainer = styled.div`
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: ${colors.blackTwelve};
`;
